const getSampleData = ({ data, columnIndex }) => {
  if (typeof columnIndex !== 'number' || data.length < 2) {
    return [];
  }

  return data
    .filter((row) => !!row[columnIndex])
    .slice(1, 3)
    .map((row) => row[columnIndex]);
};

export default getSampleData;
